import { render } from "./AddNew.vue?vue&type=template&id=ba18bc2a&scoped=true"
import script from "./AddNew.vue?vue&type=script&lang=js"
export * from "./AddNew.vue?vue&type=script&lang=js"

import "./AddNew.vue?vue&type=style&index=0&id=ba18bc2a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ba18bc2a"

export default script